export type DashboardDensity = 'standard' | 'compact';

const STORAGE_PREFIX = 'teks-time-attendance-dashboard-density';

export function getDashboardDensity(userId?: string): DashboardDensity {
  try {
    const key = userId ? `${STORAGE_PREFIX}-${userId}` : STORAGE_PREFIX;
    const value = localStorage.getItem(key);
    return value === 'compact' ? 'compact' : 'standard';
  } catch {
    return 'standard';
  }
}

export function setDashboardDensity(userId: string | undefined, density: DashboardDensity): void {
  try {
    const key = userId ? `${STORAGE_PREFIX}-${userId}` : STORAGE_PREFIX;
    localStorage.setItem(key, density);
  } catch {
    // ignore storage errors
  }
}

export function isCompact(density: DashboardDensity): boolean {
  return density === 'compact';
}

export const COMPACT_TIMING_RULES = 'Grace 10m · Slightly Late | Late 15m | no call/no show 30m';
